import { render, staticRenderFns } from "./BodegaView.vue?vue&type=template&id=5835caca&scoped=true"
import script from "./BodegaView.vue?vue&type=script&lang=js"
export * from "./BodegaView.vue?vue&type=script&lang=js"
import style0 from "./BodegaView.vue?vue&type=style&index=0&id=5835caca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835caca",
  null
  
)

export default component.exports